import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
// React Bootstrap components use the same Bootstrap stylesheet bundled in public as the PRO edition.
import "semantic-ui-css/semantic.min.css";
import "./styles/AppTheme.css";
import { Provider } from "react-redux";
import store from "./store";

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById("root")
);
